import { render, staticRenderFns } from "./detailProducts.vue?vue&type=template&id=4621b716"
import script from "./detailProducts.vue?vue&type=script&lang=js"
export * from "./detailProducts.vue?vue&type=script&lang=js"
import style0 from "./detailProducts.vue?vue&type=style&index=0&id=4621b716&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports